import React from 'react';
import { isEmpty } from 'lodash';
import { bool, number, object } from 'prop-types';
import MultiSelect from '../../../ui-components/multi-select/multi-select.jsx';
import SearchCriteriaModalCriteriaCategory from './search-criteria-modal-criteria-category.jsx';
import SearchCriteriaModalCriteriaName from './search-criteria-modal-criteria-name.jsx';
import SearchCriteriaModalCriteriaOperator from './search-criteria-modal-criteria-operator.jsx';
import {
   dashboardSearchCriteriaModalConfig,
   getLabelValuePairFromConfig,
   OPERATOR_OPTIONS,
   updateAndGetSearchCriteria,
} from './search-criteria-modal-util.js';

const SearchCriteriaModalAddRow = ({
   isEmptyFieldPresent,
   addedSearchCriteria,
   rowIndex,
   rowValue,
   appConfigs,
   updateSearchCriteria,
   recommCompetitor,
}) => {
   const criteriaCategoryOptions = dashboardSearchCriteriaModalConfig(
      rowValue.criteriaCategory.pickOptionsFrom,
      recommCompetitor
   );
   let criteriaNameOptions = dashboardSearchCriteriaModalConfig(
      rowValue.criteriaName.pickOptionsFrom,
      recommCompetitor
   );
   let criteriaName = isEmpty(rowValue.criteriaName.selectedValue)
      ? criteriaNameOptions[0].value
      : rowValue.criteriaName.selectedValue;
   const criteriaOperator = isEmpty(rowValue.criteriaOperator)
      ? OPERATOR_OPTIONS[0].value
      : rowValue.criteriaOperator;

   const handleCriteriaCategoryOnChange = (
      selectedValue,
      searchCriteria,
      rIndex
   ) => {
      criteriaNameOptions = dashboardSearchCriteriaModalConfig(
         selectedValue,
         recommCompetitor
      );
      criteriaName = criteriaNameOptions[0].value;
      updateSearchCriteria(
         updateAndGetSearchCriteria(
            'criteriaCategory',
            searchCriteria,
            rIndex,
            selectedValue,
            criteriaName
         )
      );
   };
   const handleCriteriaNameOnChange = (
      selectedValue,
      searchCriteria,
      rIndex
   ) => {
      updateSearchCriteria(
         updateAndGetSearchCriteria(
            'criteriaName',
            searchCriteria,
            rIndex,
            selectedValue
         )
      );
   };
   const handleCriteriaOperatorOnChange = (
      selectedValue,
      searchCriteria,
      rIndex
   ) => {
      updateSearchCriteria(
         updateAndGetSearchCriteria(
            'criteriaOperator',
            searchCriteria,
            rIndex,
            selectedValue
         )
      );
   };
   const handleCriteriaValueOnChange = (
      selectedValues,
      searchCriteria,
      rIndex,
      allOptions
   ) => {
      updateSearchCriteria(
         updateAndGetSearchCriteria(
            'criteriaValue',
            searchCriteria,
            rIndex,
            selectedValues,
            criteriaName,
            allOptions
         )
      );
   };

   return (
      <>
         <div className='col-sm-3'>
            <SearchCriteriaModalCriteriaCategory
               key={rowValue.criteriaCategory.pickOptionsFrom}
               criteriaCategoryOptions={criteriaCategoryOptions}
               criteriaCategory={rowValue.criteriaCategory.selectedValue}
               criteriaCategoryOnChangeHandler={handleCriteriaCategoryOnChange}
               rowIndex={rowIndex}
               criteriaName={criteriaName}
               completeSearchSet={addedSearchCriteria}
            />
         </div>
         <div className='col-sm-3'>
            <SearchCriteriaModalCriteriaName
               key={`${rowValue.criteriaCategory.pickOptionsFrom}-${rowValue.criteriaName.pickOptionsFrom}`}
               criteriaNameOptions={criteriaNameOptions}
               criteriaName={criteriaName}
               criteriaNameOnChangeHandler={handleCriteriaNameOnChange}
               rowIndex={rowIndex}
               completeSearchSet={addedSearchCriteria}
            />
         </div>
         <div className='col-sm-2'>
            <SearchCriteriaModalCriteriaOperator
               key={`${rowValue.criteriaCategory.pickOptionsFrom}-${rowValue.criteriaName.pickOptionsFrom}-${rowValue.criteriaOperator}`}
               criteriaOperator={criteriaOperator}
               criteriaOperatorOnChangeHandler={handleCriteriaOperatorOnChange}
               rowIndex={rowIndex}
               completeSearchSet={addedSearchCriteria}
            />
         </div>
         <div className='col-sm-3'>
            <MultiSelect
               placeHolder={'Value Type'}
               className={
                  isEmptyFieldPresent &&
                  isEmpty(rowValue.criteriaValue.selectedValues)
                     ? 'border-error'
                     : ''
               }
               key={`${rowValue.criteriaCategory.pickOptionsFrom}-${rowValue.criteriaName.pickOptionsFrom}-${rowValue.criteriaValue.pickOptionsFrom}`}
               options={getLabelValuePairFromConfig(appConfigs, criteriaName)}
               rowIndex={rowIndex}
               selectedValues={rowValue.criteriaValue.selectedValues}
               multiSelectOnChangeHandler={handleCriteriaValueOnChange}
               completeSearchSet={addedSearchCriteria}
            />
         </div>
      </>
   );
};

SearchCriteriaModalAddRow.propTypes = {
   appConfigs: object,
   isEmptyFieldPresent: bool,
   rowIndex: number,
};

export default SearchCriteriaModalAddRow;
